import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import DialerContactRecord from './DialerContactRecord'
import DialerDetailsCard from './DialerDetailsCard'

export default function Dialer() {
	const { t } = useTranslation()
	const [dialerDetails, setDialerDetails] = useState({
		placowkaName: '',
		placowkaAddress: '',
		representativeName: '',
		representativePhone: '',
		callSummary: '',
	})

	const handleFacilityNameUpdate = placowkaName => {
		setDialerDetails(current => ({
			...current,
			placowkaName,
		}))
	}

	const handleFacilityAddressUpdate = placowkaAddress => {
		setDialerDetails(current => ({
			...current,
			placowkaAddress,
		}))
	}

	const handleRepresentativeNameUpdate = representativeName => {
		setDialerDetails(current => ({
			...current,
			representativeName,
		}))
	}

	const handleRepresentativePhoneUpdate = representativePhone => {
		setDialerDetails(current => ({
			...current,
			representativePhone,
		}))
	}

	return (
		<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
			<div className="mb-6">
				<h1 className="text-2xl font-semibold text-gray-900">
					{t('dialer.title')}
				</h1>
			</div>

			<div className="mb-6">
				<DialerDetailsCard
					dialerDetails={dialerDetails}
					onFacilityAddressUpdate={handleFacilityAddressUpdate}
					onFacilityNameUpdate={handleFacilityNameUpdate}
					onRepresentativeNameUpdate={handleRepresentativeNameUpdate}
					onRepresentativePhoneUpdate={handleRepresentativePhoneUpdate}
				/>
			</div>

			<DialerContactRecord dialerDetails={dialerDetails} />
		</div>
	)
}
